// extracted by mini-css-extract-plugin
export default {"exchange-rate":"ExchangeRate__exchange-rate--yHb7D"};